/**
 * Agrupación del equipo por departamento — para la entrada (Home) y el mostrador
 * del rail (rediseño Home v2). Data-driven (R-PT-02): el orden de los
 * departamentos es el de PRIMERA APARICIÓN en `agents_visibles`, así el
 * descriptor manda (DKtec lo codifica Dirección→Control; Koana trae los suyos).
 * Dentro de cada departamento la orquestadora va primero (rol ~ /orquest/) y el
 * resto conserva el orden del descriptor. Un agente sin `departamento` cae en un
 * grupo de reserva para no perderse.
 */

const FALLBACK_DEPT = 'Equipo'

function esOrquestadora(a) {
  return /orquest/i.test(a?.rol ?? '')
}

// Estable: orquestadora(s) primero, resto en su orden original.
function orquestadoraPrimero(list) {
  const orq = list.filter(esOrquestadora)
  const resto = list.filter(a => !esOrquestadora(a))
  return [...orq, ...resto]
}

// Estable: el líder (un solo agente con `lidera`) primero, resto en su orden.
function liderPrimero(list) {
  const i = list.findIndex(a => a?.lidera === true)
  return i <= 0 ? list : [list[i], ...list.slice(0, i), ...list.slice(i + 1)]
}

// Devuelve [{ departamento, agents }] preservando el orden de aparición.
// GEN-191: con `lideresPrimero`, el agente que lidera su departamento (`lidera`)
// va el primero de su columna; el resto, en el orden de siempre.
export function groupByDepartment(agents = [], { lideresPrimero = false } = {}) {
  const order = []
  const byDept = new Map()
  for (const a of agents) {
    const dept = String(a?.departamento ?? '').trim() || FALLBACK_DEPT
    if (!byDept.has(dept)) {
      byDept.set(dept, [])
      order.push(dept)
    }
    byDept.get(dept).push(a)
  }
  return order.map(departamento => ({
    departamento,
    agents: lideresPrimero
      ? liderPrimero(orquestadoraPrimero(byDept.get(departamento)))
      : orquestadoraPrimero(byDept.get(departamento)),
  }))
}
